import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigCompareHomeComponent } from './config-compare-home/config-compare-home.component';
import { ConfigCompareNavigateComponent } from './config-compare-navigate/config-compare-navigate.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { SelectComponent } from './select/select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ConfigPopupComponent } from './config-popup/config-popup.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SubmitComponent } from './submit/submit.component';
import { CompareComponent } from './compare/compare.component';
import { FileCompareSubmitComponent } from './file-compare-submit/file-compare-submit.component';



const routes: Routes = [
  {
    path: "", component: ConfigCompareNavigateComponent, children: [
      { path: "select", component: SelectComponent },
      { path: "", component: ConfigCompareHomeComponent, pathMatch: "full" },
      { path: "submit", component: SubmitComponent },
      { path: "compare", component: CompareComponent },
      { path: "compare_file_submit", component: FileCompareSubmitComponent }  
      
    ],
  },
];


@NgModule({
  declarations: [SelectComponent, ConfigCompareHomeComponent, ConfigCompareNavigateComponent, ConfigPopupComponent, SubmitComponent, CompareComponent, FileCompareSubmitComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule, ReactiveFormsModule,
    RouterModule.forChild(routes),
    NgxPaginationModule,
    Ng2SearchPipeModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfigCompareModule { }
